export default function PHP_disk_total_space() {
  return (
    <div>
      <h1>PHP_disk_total_space</h1>
    </div>
  );
}
